import React, { useContext, useState } from "react";
import { Box, Grid } from "@mui/material";
import NavBar from "./NavBar";
import { Outlet } from "react-router-dom";
import { useNavbarContext } from "../../context/NavbarContext";
import FeedbackWidget from "../Feedback/FeedbackWidget";

const DashboardBFC = (props: any) => {
  const { isNavbarOpen, setIsNavbarOpen } = useNavbarContext();

  return (
    <div>
      {isNavbarOpen ? (
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-5">
          {/* min-h (not a fixed grid row) so the white panel grows with the nav
              list — a fixed 850px row let the last items spill out of the card. */}
          <div className="col-span-1 min-w-0">
            <div className="min-h-[850px] h-auto bg-white rounded-lg shadow-md">
              <NavBar />
            </div>
          </div>

          {/* col-span-4 only once the 5-column track exists; below `lg` the grid
              is 1 column and a span-4 item would create 4 implicit auto-width
              columns, pushing the content out of the page container. */}
          <div className="col-span-1 lg:col-span-4 min-w-0">
            <Outlet />
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-5 gap-5">
          <div className="col-start-1 col-span-5">
            <Outlet />
          </div>
        </div>
      )}
      <FeedbackWidget />
    </div>
  );
};

export default DashboardBFC;
